import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import type { FlexProps } from "@similarweb/ui-components/foundations";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { InfoTooltip } from "app/pages/digital-marketing/common/ui/InfoTooltip";

interface IInputLabelProps extends FlexProps {
    infoTooltip?: ReactNode;
}

export const InputLabel = ({
    infoTooltip,
    color = colorsPalettes.carbon["300"],
    children,
    ...rest
}: IInputLabelProps) => {
    return (
        <Flex
            as="label"
            gap="4px"
            alignItems="center"
            {...rest}
        >
            <Text
                fontVariant="caption"
                color={color}
            >
                {children}
            </Text>
            <InfoTooltip
                content={infoTooltip}
                iconColor={color}
            />
        </Flex>
    );
};
